import WebApi from "@/views/loyalty/shared/modules/web_api"

export class JustpayPointEndpoint {
    constructor () {
        this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/point/`
        this.webApi = new WebApi()
    }

    async checkOwnedEquipment (equipmentId) {
        const isOwned = await this.webApi.get(`${this.url}check/${equipmentId}`)
        if (isOwned) {
            if (!isOwned.status_code) {
                if (!isOwned.error) {
                    return isOwned
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${isOwned.status_code}`)
            }
        }
        return null
    }

    async getAllPoints () {
        const points = await this.webApi.post(`${this.url}list`, { id: null, page: 1, limit: -1 })
        // console.log('points:', points)
        if (points) {
            if (!points.status_code) {
                if (!points.error) {
                    return points
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${points.status_code}`)
            }
        }
        return null
    }

    async getAllPointsbyClientId (clientId) {
        const points = await this.webApi.post(`${this.url}list`, { clientId: clientId })
        // console.log('points:', points)
        if (points) {
            if (!points.status_code) {
                if (!points.error) {
                    return points
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${points.status_code}`)
            }
        }
        return null
    }

    async getPoint (jsonArg) {
        const point = await this.webApi.post(`${this.url}get`, jsonArg)
        if (point) {
            if (!point.status_code) {
                if (!point.error) {
                    return point
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${point.status_code}`)
            }
        }
        return null
    }

    async getPoints (jsonArg) {
        const point = await this.webApi.post(`${this.url}getBy`, jsonArg)
        if (point) {
            if (!point.status_code) {
                if (!point.error) {
                    return point
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${point.status_code}`)
            }
        }
        return null
    }

    async getPointsForFiltering () {
        const point = await this.webApi.get(`${this.url}GetForFiltering`)
        if (point) {
            if (!point.status_code) {
                if (!point.error) {
                    return point
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${point.status_code}`)
            }
        }
        return null
    }

    async getPointMonitoring () {
        const points = await this.webApi.post(`${this.url}list`, { id: '63e507f9551d3d53780e978c', monitoring_date: '2023-09-01' })
        console.log('points:', points)
        if (points) {
            if (!points.status_code) {
                if (!points.error) {
                    return points
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${points.status_code}`)
            }
        }
        return null
    }
}
